var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Yukleniyor',{attrs:{"data":_vm.loading}}),_vm._v(" "),(!_vm.loading & _vm.KurulumIslemi)?_c('Kurulum',{attrs:{"Bina_id":_vm.Bina_id}}):_vm._e(),_vm._v(" "),(!_vm.loading & !_vm.KurulumIslemi)?_c('Ekran',{attrs:{"BinaBilgi":_vm.BinaBilgi}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5811b5e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Yonetim/bina/Detay.vue
// module id = 847
// module chunks = 0